module.exports = __webpack_public_path__ + "static/media/co.c5d7116a.svg";